import React, { useState,useEffect } from 'react';
import '../CSS/header.css';
import SettingsImage from '../Settings.png';
import SettingsModal from './SettingsModal';
import db from "../FireBase/firebase"; 
import { ref, onValue } from "firebase/database"; 

function Header({ toggleCompteur, toggleDonnees, toggleTemperature, toggleMesure, toggleGraphe }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [settings, setSettings] = useState({
    compteur: true,
    donnees: false,
    temperature: true,
    mesure: true,
  });

  const [mesures, setMesures] = useState([]);
  const [paramGraph, setParamGraph] = useState([]);
  
  useEffect(() => {
    const paramRef = ref(db, "parametres/mesures");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const data = childSnapshot.val().visible;
          fetchedMesures.push({ id: key , visible: data });
        });
        setMesures(fetchedMesures);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );
  
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const paramRef = ref(db, "parametres/graphes");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const data = childSnapshot.val();
          fetchedMesures.push({ id: key, ...data });
        });
        setParamGraph(fetchedMesures);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );
  
    return () => unsubscribe();
  }, []);

  const handleSettingsChange = (settingKey) => {
    setSettings((prevSettings) => {
      const newValue = !prevSettings[settingKey];
  
      
      const newSettings = { ...prevSettings, [settingKey]: newValue };
  
      
      switch (settingKey) {
        case 'compteur':
          toggleCompteur(newValue);
          break;
        case 'donnees':
          toggleDonnees(newValue);
          break;
        case 'temperature':
          toggleTemperature(newValue);
          break;
        default:
          
          if (mesures.some((mesure) => mesure.id === settingKey)) {
            const mesure = mesures.find((mesure) => mesure.id === settingKey);
            toggleMesure(mesure.id, !mesure.visible);
          }
          if (paramGraph.some((graphe) => "Graphe"+graphe.id === settingKey)) {
            const graphe = paramGraph.find((graphe) => "Graphe"+graphe.id === settingKey);
            toggleGraphe(graphe.id, !graphe.visible);
          }
          break;
      }
  
      return newSettings;
    });
  };

  return (
    <div className="header">
      <h1>Hyperbole Visualiser</h1>
      <button onClick={() => setIsModalOpen(true)}>
        <img src={SettingsImage} alt="settings" />
      </button>

      
      <SettingsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} settings={settings} handleSettingsChange={handleSettingsChange} />
    </div>
  );
}

export default Header;
